/*
  ASTRAY ACCESS — redeem adapter
  Called by the Astray Access section: window.AstrayAccess.redeem({ rewardId, title, km, button })
  rewardId is "CODE" (money rewards) or "CODE|VARIANT_ID" (physical rewards).

  Physical rewards are $0 items: added to the cart (no discount code), so they work
  alongside any other discount. Money rewards ($10 / $25 / free shipping) are codes,
  one code per order. Before adding anything, the km already committed in the cart
  (reward items x quantity + any Access code) are added up and checked against the
  member's available km, so the cart can never ask for more km than they have.
  km come off when the order is placed (Shopify Flow). Never leaves the page.
*/
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function api(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    return fetch(ROOT + url, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }

  function openCart() {
    var e = window.essentialCartApi;
    if (e && typeof e.openCart === 'function') {
      try { if (typeof e.refreshCart === 'function') e.refreshCart(); } catch (err) {}
      e.openCart();
      return;
    }
    if (typeof window.updateCart === 'function') window.updateCart();
    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
  }

  function codesOf(cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) { return String(d.code); });
  }
  function same(a, b) { return a.toUpperCase() === b.toUpperCase(); }

  // Reward costs, read from the reward cards on the Access page
  function rewardCosts() {
    var byVariant = {}, byCode = {};
    document.querySelectorAll('[data-aa-redeem]').forEach(function (b) {
      var p = String(b.dataset.aaRedeem || '').split('|');
      var km = parseInt(b.dataset.aaKm, 10) || 0;
      if (p[1]) byVariant[parseInt(p[1], 10)] = km;
      else if (p[0]) byCode[p[0].trim().toUpperCase()] = km;
    });
    return { byVariant: byVariant, byCode: byCode };
  }

  function available() {
    var el = document.querySelector('[data-aa-available]');
    return el ? (parseInt(el.getAttribute('data-aa-available'), 10) || 0) : 0;
  }

  function committed(cart, costs) {
    var km = 0;
    (cart.items || []).forEach(function (i) {
      if (costs.byVariant[i.variant_id]) km += costs.byVariant[i.variant_id] * i.quantity;
    });
    codesOf(cart).forEach(function (c) {
      if (costs.byCode[c.toUpperCase()]) km += costs.byCode[c.toUpperCase()];
    });
    return km;
  }

  function tooMuch(reward, cart, costs) {
    var have = available();
    var used = committed(cart, costs);
    if (used + (reward.km || 0) <= have) return null;
    if (reward.button) reward.button.disabled = false;
    return { label: 'Redeem', message: 'Not enough km. You have ' + have + ' km and your cart already uses ' + used + ' km.' };
  }

  function addItem(vid, reward) {
    var costs = rewardCosts();
    return api('cart.js').then(function (cart) {
      var inCart = (cart.items || []).some(function (i) { return i.variant_id === vid; });
      if (inCart) {
        openCart();
        return { label: 'In your cart', message: reward.title + ' is already in your cart.' };
      }
      var block = tooMuch(reward, cart, costs);
      if (block) return block;
      return api('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function () {
          openCart();
          return { label: 'In your cart', message: reward.title + ' added. Free — your km come off when you order.' };
        });
    });
  }

  function applyCode(code, reward) {
    var costs = rewardCosts();
    return api('cart.js').then(function (cart) {
      var codes = codesOf(cart);
      if (codes.some(function (c) { return same(c, code); })) {
        openCart();
        return { label: 'Applied', message: reward.title + ' is already applied.' };
      }
      if (codes.length) {
        if (reward.button) reward.button.disabled = false;
        return { label: 'Redeem', message: 'One code per order. Your cart already has ' + codes.join(', ') + '. Remove it first to use this reward.' };
      }
      var block = tooMuch(reward, cart, costs);
      if (block) return block;
      return api('cart/update.js', { method: 'POST', body: JSON.stringify({ discount: code }) })
        .catch(function () { return null; })
        .then(function (c) {
          if (c && codesOf(c).some(function (x) { return same(x, code); })) return c;
          return fetch(ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'),
            { credentials: 'same-origin' });
        })
        .then(function () {
          openCart();
          return { label: 'Applied', message: reward.title + ' applied. Your km come off when you order.' };
        });
    });
  }

  window.AstrayAccess = window.AstrayAccess || {};
  window.AstrayAccess.redeem = function (reward) {
    var parts = String(reward.rewardId || '').split('|');
    var code = parts[0].trim();
    var vid = parts[1] ? parseInt(parts[1], 10) : 0;
    if (vid) return addItem(vid, reward);
    if (code) return applyCode(code, reward);
    return Promise.reject(new Error('Reward is not set up'));
  };
})();
